import { mapStylesToPreviewCssProps } from '../../../../utils/util';
import type { PreviewImageElementProps } from './types';

const usePresenter = ({ element, style, ...otherProps }: PreviewImageElementProps): PreviewImageElementProps => {
  return {
    element,
    style: {
      ...mapStylesToPreviewCssProps(element.styles),
      ...style,
    },
    ...otherProps,
  };
};

export default usePresenter;
